import * as luxon from 'luxon';
import Vue from 'vue';
import DocumentData = firebase.firestore.DocumentData;
import { MAFUser } from '@/store/User/types';
import { DateTime } from 'luxon';
import { baseClass, Lookup } from '@/store/types';
import * as firebase from 'firebase';
import DocumentReference = firebase.firestore.DocumentReference;
import Timestamp = firebase.firestore.Timestamp;

// TODO: fix variable names
/* tslint:disable:variable-name */
export interface ViolationState {
    violations: MAFViolation[] | undefined;
    resolutions: Lookup | undefined;
    allUsers: MAFUser[] | undefined;
}

export interface Violation {
    user_reported?: MAFUser | undefined;
    issue_reported: string| undefined;
    issue_details: string | undefined;
    date: Date | string |undefined;
    reporter?: MAFUser | undefined;
    resolution: string | undefined;
    imageUrl?: string|undefined;
}

export class MAFViolation extends baseClass implements Violation {
    get report_name(): string {
        if (this.reporter && this.reporter.name) {
            return this.reporter.name;
        }
        return '';
    }
    get report_type(): string {
        if (this.reporter && this.reporter.userType) {
            return this.reporter.userType;
        }
        return '';
    }
    get report_email(): string {
        if (this.reporter && this.reporter.email) {
            return this.reporter.email;
        }
        return '';
    }
    get user_name(): string {
        if (this.user_reported && this.user_reported.name) {
            return this.user_reported.name;
        }
        return '';
    }
    get user_type(): string {
        if (this.user_reported && this.user_reported.userType) {
            return this.user_reported.userType;
        }
        return '';
    }
    get user_email(): string {
        if (this.user_reported && this.user_reported.email) {
            return this.user_reported.email;
        }
        return '';
    }
    // public Reporter: MAFUser |undefined;
   // public User_reported: MAFUser |undefined;

    // document reference for updating the violation
    public Reference: DocumentReference | undefined;

    public user_reported?: MAFUser | undefined;
    public issue_reported: string | undefined;
    public issue_details: string | undefined;
    public date: Date | string | undefined;
    public reporter?: MAFUser | undefined;
    public resolution: string | undefined;
    public imageUrl: string|undefined;

    constructor(payload: MAFViolation | DocumentData | undefined) {
        super();
        if (payload) {
            this.user_reported = (payload.user_reported) ? payload.user_reported : undefined;
            this.issue_reported = payload.issue_reported;
            this.issue_details = payload.issue_details;
            this.date = baseClass.convertToJSDate(payload.date);
            this.reporter = (payload.reporter) ? payload.reporter : undefined;
            this.resolution = payload.resolution;
            this.imageUrl = payload.imageUrl;
        }
    }

    public setDocumentReference(doc: DocumentReference) {
        this.Reference = doc;
    }

    public toPlainObj(): object {
        return {
            user_reported: this.user_reported,
            issue_reported: this.issue_reported,
            issue_details: this.issue_details,
            date: this.date instanceof Date ? Timestamp.fromDate(this.date) : this.date,
            reporter: this.reporter,
            resolution: this.resolution,
            imageUrl: this.imageUrl,
        };
    }

    /**
     * Get the refernce for the Document References
     * (Reported/Reportee) and their corresponding MAFUser
     */
    // public getUsers() {
    //     const self = this;
    //     return new Promise(( (resolve) => {
    //         let count = 0;
    //         let total = 0;

    //         if (self.user_reported) {
    //             total ++;
    //             if (self.reporter) {
    //                 total ++;
    //             }
    //             const ir = self.user_reported.get().then((doc : any) => {
    //                 count ++;
    //                 self.User_reported = new MAFUser(doc.data()); // Set MAFUser to User_reported
    //                 if (count === total) {
    //                     resolve();
    //                 }
    //             });
    //             if (self.reporter) {
    //                 self.reporter.get().then((doc : any) => {
    //                     count++;
    //                     this.Reporter = new MAFUser(doc.data()); // Set MAFUser to Reporter
    //                     if (count === total) {
    //                     resolve();
    //                     }
    //                 });
    //             }
    //         } else if (self.reporter) {
    //             self.reporter.get().then((doc : any) => {
    //                 this.Reporter = new MAFUser(doc.data()); // Set MAFUser to Reporter
    //                 resolve();
    //             });
    //         } else {
    //             resolve();
    //         }
    //     }));
    // }
}

